import { createStyles, makeStyles } from '@material-ui/styles';
import palette from 'theme/palette';

const style = () =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      gap: '10px'
    },
    title: {
      color: palette.common.black,
      fontSize: '1.25rem'
    },
    winner: {
      display: 'flex',
      alignItems: 'center',
      gap: '15px',
      color: palette.text.primary,
      background: palette.background.underBox,
      borderRadius: palette.borderRadius.default,
      '& > p': {
        fontSize: '1.2rem'
      }
    },
    avatarContainer: {
      minWidth: '57px'
    },
    name: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: '5px 10px',
      alignItems: 'center',
      background: palette.background.underBox,
      color: palette.text.darker,
      fontSize: '1.2rem',
      borderRadius: palette.borderRadius.default,
      padding: '3px 0px',
      width: 'max-content'
    },
    lyceeName: {
      fontSize: '0.8rem'
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
